// ============================================================================
// Products-Supply flip — cascading 1->2->3->4->5 image swap with rest periods
// ============================================================================
(function ($) {
    'use strict';

    const reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    $(function () {
        const root = document.querySelector('[data-products-supply]');
        if (!root) return;

        const photos = Array.from(root.querySelectorAll('.products-supply__photo'));
        if (!photos.length) return;

        const pool = Array.from(new Set(
            Array.from(root.querySelectorAll('.products-supply__face img'))
                .map(img => img.getAttribute('src'))
        ));
        if (pool.length < 2) return;

        // Cadence (ms)
        const initialWait      = 4000;
        const stepDelay        = 700;
        const cycleDuration    = 1000;
        const restBetweenCycles = 7000;

        function pickDifferent(current) {
            if (pool.length < 2) return current;
            let pick = current;
            for (let i = 0; i < 6 && pick === current; i++) {
                pick = pool[Math.floor(Math.random() * pool.length)];
            }
            return pick;
        }

        function flipPhoto(photo) {
            const flipper = photo.querySelector('.products-supply__flipper');
            if (!flipper) return;

            const showingBack = flipper.classList.contains('is-flipped');
            const upcomingSel = showingBack ? '.products-supply__face--front' : '.products-supply__face--back';
            const currentSel  = showingBack ? '.products-supply__face--back'  : '.products-supply__face--front';

            const upcomingImg = photo.querySelector(`${upcomingSel} img`);
            const currentImg  = photo.querySelector(`${currentSel} img`);
            if (upcomingImg && currentImg) {
                upcomingImg.src = pickDifferent(currentImg.src);
            }

            requestAnimationFrame(function () {
                flipper.classList.toggle('is-flipped');
            });
        }

        function runCascade() {
            photos.forEach(function (photo, idx) {
                setTimeout(function () { flipPhoto(photo); }, idx * stepDelay);
            });
            const totalCascade = (photos.length - 1) * stepDelay + cycleDuration;
            scheduleNext(totalCascade + restBetweenCycles);
        }

        function scheduleNext(delay) {
            setTimeout(function () {
                if (document.hidden) {
                    scheduleNext(2000);
                    return;
                }
                runCascade();
            }, delay);
        }

        function whenRevealed(cb) {
            if (root.classList.contains('is-revealed')) {
                setTimeout(cb, initialWait);
                return;
            }
            const obs = new MutationObserver(function () {
                if (root.classList.contains('is-revealed')) {
                    obs.disconnect();
                    setTimeout(cb, initialWait);
                }
            });
            obs.observe(root, { attributes: true, attributeFilter: ['class'] });
        }

        whenRevealed(runCascade);
    });
})(jQuery);
